// extracted by mini-css-extract-plugin
module.exports = {"markdown-document":"markdown-document_markdown-document__zScyE","markdown-document-content":"markdown-document_markdown-document-content__Ae6EY"};